module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_chapel@2x-2e6430156e74cbed3b38cd1a8837dd84.webp";